export const VERIFYINNG_ACCESS_PERMISSION = 'VERIFYINNG_ACCESS_PERMISSION'
export const ACCESS_DENIED = 'ACCESS_DENIED'
export const ACCESS_ALLOWED = 'ACCESS_ALLOWED'

const LOGIN_ROUTE = '/empresas/ingreso'

export interface DataAccessState {
  gotToLogin: string
  isVerifying: boolean
  accessAllowed: boolean
  accessDenied: boolean
}

export const InitialState: DataAccessState = {
  gotToLogin: LOGIN_ROUTE,
  isVerifying: false,
  accessAllowed: false,
  accessDenied: false,
}

export interface VerifyingAccess {
  type: typeof VERIFYINNG_ACCESS_PERMISSION
  payload: null
}

export interface AccessDenied {
  type: typeof ACCESS_DENIED
  payload: boolean
}

export interface AccessAllowed {
  type: typeof ACCESS_ALLOWED
  payload: boolean
}

export type PrivateRouteValidation = AccessAllowed | AccessDenied | VerifyingAccess
